module.exports = new __parcel__URL__("lune-pluie-2.27bccd53.svg").toString();